import { LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { UserProfile } from '../datatypes/user-profile';
import { consume } from '@lit/context';
import { UserProfileContext } from '../contexts/user-profile-context';
import { UserAccessManager } from '../utility/user-access-manager';

export const WithUserProfileConsumer = <
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- canonical TS/Lit mixin idiom: a mixin superclass constraint must accept arbitrary constructor args.
  T extends new (...args: any[]) => LitElement,
>(
  superClass: T
) => {
  class WithUserProfileConsumerClass extends superClass {
    @consume({ context: UserProfileContext, subscribe: true })
    @property({ attribute: false })
    public userProfile?: UserProfile;
    updated(changedProperties: Map<string | number | symbol, unknown>): void {
      if (changedProperties.has('userProfile')) {
        this.doUserProfileChanged();
      }
    }
    doUserProfileChanged() {
      console.log('doUserProfileChanged');
    }
    get access(): UserAccessManager | undefined {
      return this.userProfile?.access;
    }

    get isAuthenticated(): boolean {
      return !!this.userProfile;
    }
    get isSystemTenant(): boolean {
      return this.access?.hasRole('systemTenant') ?? false;
    }
  }

  return WithUserProfileConsumerClass as Constructor<WithUserProfileConsumerInterface> &
    T;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- canonical mixin Constructor helper; constructor args are necessarily arbitrary.
type Constructor<T> = new (...args: any[]) => T;

export interface WithUserProfileConsumerInterface {
  userProfile?: UserProfile;
  access?: UserAccessManager;
  isAuthenticated: boolean;
}
